// src/favorite-lists/favoriteListsApi.ts
import { apiClient } from "@maat/api-base";
var favoriteListsApi = {
  getLists: async () => {
    return apiClient.get("/main/api/favorite-lists");
  },
  getFeed: async (params) => {
    return apiClient.get("/main/api/favorite-lists/feed", { params });
  },
  getList: async (listId) => {
    return apiClient.get(`/main/api/favorite-lists/${listId}`);
  },
  createList: async (name) => {
    return apiClient.post("/main/api/favorite-lists", { name });
  },
  updateList: async (listId, name) => {
    return apiClient.put(`/main/api/favorite-lists/${listId}`, { name });
  },
  deleteList: async (listId) => {
    return apiClient.delete(`/main/api/favorite-lists/${listId}`);
  },
  addListing: async (listId, listingId) => {
    return apiClient.post(`/main/api/favorite-lists/${listId}/listings`, {
      listing_id: listingId
    });
  },
  removeListing: async (listId, listingId) => {
    return apiClient.delete(`/main/api/favorite-lists/${listId}/listings/${listingId}`);
  }
};

export {
  favoriteListsApi
};
